module.exports = __webpack_public_path__ + "img/otopack150-badge.76dd90b4.svg";